<template>
  <div class="indexPage footerPosition">
       <topInfo></topInfo> 
       <div class="pageCom">
         <div class="pageBanner"></div>
         
         <div class="pageContent">
           <div class="pageTop">
              <div class="l leftTop">
                  <ul>
                    <li><img src="../../../../static/img/fyImg/fyCertificate1.jpg" /></li>
                    <li><img src="../../../../static/img/fyImg/fyCertificate2.jpg" /></li>
                  </ul>
              </div>
              <div class="l rightTop">
                <a @click="clkVideoBtn" style="cursor:pointer;width:100px;height:100px;margin:auto;display:block;" ><img src="../../../../static/img/fyImg/videoClk.png" width="100" height="100"></a>
              </div>

              <!-- <div class="dialogBox videoSet">
                  <el-dialog title="Video Display" :visible.sync="fyVideoBox" @close="closeVideo" :close-on-click-modal="false" custom-class="borRad10" width="720px">
                    <div>
                         <video class="vidTv" ref="fyVideo" src="../../../../static/video/videoAll.mp4" preload controls height="395" width="698"> </video>
                    </div>
                  </el-dialog>
              </div> -->

            <!--完整视频弹框  start-->
              <div class="frameBg" v-show="showModal"></div>
              <div v-show="fyVideoBox">
                <div class="frameInput" style="width:700px;margin-left:-351px;">
                  <div class="frameHead clear">
                    <p class="l">Video Display</p><p @click="closeVideo" class="r">×</p>
                  </div>
                  <div class="content">
                    <video class="vidTv" ref="fyVideo" src="../../../../static/video/fyVideo.mp4" preload controls height="395" width="680"> </video>
                  </div>
                </div>
              </div>
          <!--完整视频弹框  end-->
           </div>
            <div class="pageMargin">
              <div class="pageCountry" id="countryId">
                 <h2>Purchase of epidemic prevention materials</h2>
                 <div class="countryInput">
                   <b class="l toTitle">TO:</b>
                   <div class="l" >
                      <expDesCountry class="videoCountry l" setWidth="300px" height="29px" setPlaceholder="Please select country" :class="isTrueBor? 'fyBorRed':''"
									 	@byCountryValue="byCountryValue"></expDesCountry>
                     <b class="colRed l marL5" style="line-height:30px;" v-show="isTrueBor">Required</b>
                   </div>
                   <div class="cl"></div>
                 </div>
                 <div class="noteSet"><i class="fa fa-tips colRed marR5"></i>Note: All protective supplies include shipping</div>
              </div>
              <div class="pageProduct">
                  <ul>
                    <li v-for="(item,index) in fyProList" :key="index">
                      <p><img :src="item.proImgRul" width="270" /></p>
                      <p class="buleBg" :title="item.proTips"><i class="fa fa-steps5" style="margin:-3px 2px 0;"></i>{{item.proTips}}</p>
                      <div class="proSet">
                          <h3 :title="item.proName">{{item.proName}}</h3>
                          <div class="labelBtn">
                            <a v-for="tag in item.options" :key="tag.pcs" class="btn" :class="tag.isTrue?'btnOn':''"  @click="clkPcsBtn(item,tag.pcs)" >
                              <span class="iconYeSet" v-if="tag.isTrue"><img src="../../../../static/img/fyImg/iconYeFinish.png"/></span>{{tag.pcs}}Pcs</a>
                          </div>
                          <div><a class="PriceBtn" @click="clkBtnPrice(item)">{{item.btnText}}</a></div>
                      </div>
                    </li>
                  </ul>
              </div>
              <div class="footerCentet">
                <div class="footerLeft"><img src="../../../../static/img/fyImg/fyBotIcon.png" width="77" height="85" /> </div>
                <div class="footerRight">
                  <h1>How dangerous is this coronavirus?</h1>
                  <p>Different from other coronaviruses, this novel corona virus is infectious from human to human, it can be transmitted while an infected person still isn't showing any symptoms.</p>
                  <p>Here are coronavirus supplies you will need to prepare for coronavirus. Protect yourself against COVID-19 disease.</p>
                </div>
              </div>
               <!-- 邮箱手机号码填写 弹框 start-->
                  <div class="dialogBox">
                      <el-dialog title="Contact Customer Service" :visible.sync="emailBox" @close="closeEmailBtn" :close-on-click-modal="false" custom-class="borRad10" width="540px">
                        <div class="emailSet">
                          <p>Please leave your contact information here or <br/>send email to：<b>info@by56.com</b>；Wechat：<b>vincentchina8</b></p>
                          <table border="0" cellspacing="0" cellpadding="0" width="100%" class="detTable marTop20">
                            <tr>
                              <th align="right" width="10%" class="veTop2"><span class="marR5">Email</span></th>
                              <td align="left">
                                <input style="width:95%" class="inputLine" type="text" v-model="Email" placeholder="Please enter your Email" :class="inpBorRed ? 'borRed':''" @blur="blurEmail" />
                                <p v-show="inpBorRed" class="colRed font12" style="text-align:left;line-height:12px;">{{plaEmail}}</p>
                              </td>
                            </tr>
                            <tr>
                              <th align="right" width="10%"><span class="marR5">Phone</span></th>
                              <td align="left">
                                <input style="width:95%" class="inputLine" type="text" v-model="Phone" placeholder="Please enter your Phone" :class="inpBorRed2 ? 'borRed':''" @blur="blurPhone"/>
                              <p v-show="inpBorRed2" class="colRed font12" style="text-align:left;line-height:12px;">{{PlaPhone}}</p>
                              </td>
                            </tr>
                          </table>
                        </div>
                        <span center slot="footer" class="dialog-footer">
                          <el-button @click="closeEmailBtn">Cancel</el-button>
                          <el-button type="primary" @click="clkConfirmBtn">Confirm</el-button>
                        </span>
                      </el-dialog>
                  </div>
               <!-- 邮箱手机号码填写 弹框 end-->

            </div>
         </div>
        </div>
       <footerInfo class="fyFooter"></footerInfo>
  </div>
</template>

<script type="text/ecmascript-6">
  import Vue from "vue";
  import {getCookie,delCookie} from '../../../ask/cookiejs'
  import { post, fetch, Del, put } from "../../../ask/axios";
  import topInfo from '../public/topInfo'
  import footerInfo from '../public/footerInfo'
  import expDesCountry from '../../userCenter/public/expDesCountry'
  export default {
   components:{topInfo,footerInfo,expDesCountry},
    data (){
      return {
        api: {
          url: "",
          param: "",
          data: "",
          response: {},
          message: ""
        },

        fyVideoBox:false,
        showModal:false,

        //防疫物资商品
        fyProList:[],

        desCountryEn:'',
        desCountryCh:'',
        desCountryKey:'',
        isTrueBor:false,
        weight:0,
        cargoId:'',
        cargoNameEn:'',
        cargoNameCH:'',
        cargoCode:'',
        Qty:null,

        //客服信息
        cusInfos:'',

        //填写邮箱手机号弹框
        emailBox:false,
        Email:'',
        Phone:'',
        plaEmail:'',
        PlaPhone:'',
        inpBorRed:false,
        inpBorRed2:false,
      }
      
    },
    created(){
     this.getProList()
    },
    mounted() {

      
    },
    watch:{
       //目的国家
    desCountryKey(newValue, oldValue) {
      if (newValue) {
        this.isTrueBor = false
      }
    },

    },
    methods:{




      clkVideoBtn(){
        this.showModal=true
        this.fyVideoBox=true
        this.$refs.fyVideo.play(); //打开视频播放
        
      },
      closeVideo(){
        this.showModal=false
        this.fyVideoBox=false
        this.$refs.fyVideo.pause() //关闭的时候暂停视频
      },
      //目的国家组件取值
      byCountryValue(msg) {
        this.desCountryEn=msg.expCounEn
        this.desCountryCh=msg.expCounCh
        this.desCountryKey = msg.citykey
      },
      //===========获取产品信息===============//
       //读取产品json
        getProList(){
          fetch('/static/data/fyProductData.json').then((res) => {
            //赋值
            this.fyProList=res
          })
        },
        clkPcsBtn(item,pcs){ //点击选项按钮
          item.options.forEach(e =>{
            if(pcs==e.pcs){
              Vue.set(e, 'isTrue', true)        
            }else{
              Vue.set(e, 'isTrue', false) 
            }
          })   
        },

       //定位
       goToBat(){
          $("html,body").animate({scrollTop: $("#countryId").offset().top}, 800);
        },

        //自动关闭
        closeConfirm(){
            setTimeout(() => {
              $('.custom-message-box').find('.el-button').trigger('click');
                return false
            },1000)
        },
        

      //点击按钮查价
      clkBtnPrice(item){
          //第一步 判断目的国家是否必填
          if(!this.desCountryKey){
              this.isTrueBor=true
              this.goToBat()
              return false
          }
          //第二步 判断是否选择件数
          let isChosePcs=false
          item.options.forEach(e =>{
            if(e.isTrue){
              isChosePcs=true              
              return false
            }
          })

          if(!isChosePcs){
             // this.$message.warning('Please select quantity');
              this.$confirm( 'Please select quantity','',  {
                duration:'3000',
                customClass:'custom-message-box', //自定义添加Class
                confirmButtonText: 'Confirm',
                cancelButtonText: 'Cancel',
                cancelButtonClass: 'btn-custom-cancel', //添加class,更换删除和取消按钮位置
                closeOnClickModal:false,//是否可通过点击遮罩关闭 MessageBox
                showCancelButton:false,//去掉取消按钮
                showClose:false,//去掉右上角的取消（X）
                // type: 'warning',
                center: true
              }).then(() => {
                  
              }).catch(() => {
                 
              });


            setTimeout(() => {
                this.closeConfirm()
                return false
             },2000)
              

              return false 
          }

          //点击查价按钮取值
            this.cargoId=item.cargoId
            this.cargoNameEn=item.cargoNameEn
            this.cargoNameCH=item.cargoNameCH
            this.cargoCode=item.AttrVal_Code
             
          item.options.forEach(e =>{
            if(e.isTrue){
              this.weight=e.weight
              this.Qty=Number(e.pcs)           
            }
          })

          //第三步  判断是立即查价，1.登录状态直接跳转到查价结果页面，未登录则跳转到登录，登录完成直接跳转到查价结果页面
          if(item.btnText=='Check Price Now'){
            // console.log('Check Price Now' + this.cargoId);
             let w = window.open();
             w.location.href = '/exp/checkExpList?zt=1&weight='+this.weight+'&Qty='+this.Qty+'&desCountryEn='+this.desCountryEn+'&desCountryKey='+this.desCountryKey+"&cargoId="+this.cargoId+"&cargoNameEn="+this.cargoNameEn+"&cargoNameCH="+this.cargoNameCH+"&cargoCode="+this.cargoCode;
          }

          //第四步  判断是联系客服，1.是否登录，未登录直接弹框显示填写邮箱或手机号，2.登录状态，判断用户是否有邮箱，如果没有邮箱弹框填写，有邮箱则直接发送邮件
            if(item.btnText=='Inquire Now'){
              //判断登录下LoginName是否有值（邮箱），有则直接发送邮件
              if( getCookie('X-BY-EnTOKEN') ){             
                 this.cusInfos=JSON.parse(sessionStorage.getItem("customerInfos"))
                 //console.log('this.cusInfos.LoginName ' +  JSON.stringify(this.cusInfos));
                 if(this.cusInfos.LoginName){
                   //console.log('this.cusInfos.LoginName ' +  JSON.stringify(this.cusInfos.LoginName));
                    this.SendEmailApi(this.cusInfos.LoginName) //发送邮件接口
                 }else{
                    this.emailBox=true
                 }
              }else{
                //未登录则弹框提示填写信息
                 this.emailBox=true
              }   
            }
          
      },
        //邮箱弹框
      closeEmailBtn(){ //关闭邮箱
         this.emailBox=false
         this.inpBorRed=false
         this.inpBorRed2=false
         this.Email=""
         this.Phone=""
         this.PlaPhone='Please enter your Phone'
         this.plaEmail='Please enter your Email' 
      },
      clkConfirmBtn(){//邮箱确定按钮
        if(!this.Email && !this.Phone){
          this.plaEmail='Phone or email required'
          this.PlaPhone='Phone or email required'
          this.inpBorRed=true
          this.inpBorRed2=true
        }
        if(this.inpBorRed || this.inpBorRed2){
            return false  
        }

        this.SendEmailApi(this.Email)
      
      },
      blurEmail(){
        var regEmail= /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
        if(this.Email){ 
             this.inpBorRed=false
             this.inpBorRed2=false
             this.PlaPhone='Please enter your Phone'
 
            if(!regEmail.test(this.Email)){ //只能输入邮箱格式
              this.inpBorRed=true
              this.plaEmail='Please enter a valid email address'
            }
        }   

      },
      blurPhone(){
        if(this.Phone){
          this.inpBorRed=false
          this.inpBorRed2=false
          this.PlaPhone=''
          this.plaEmail='Please enter your Email'
        }
      },
      //发送邮件接口
      SendEmailApi(email){
        let that=this
        this.api.param={
           Name:this.cargoNameCH,
           Quantity:this.Qty,
           Phone:this.Phone,
           Email:email,
           CountryName:this.desCountryCh
        }
         
        this.api.url = this.$api02 + "/api/EbayCustomer/CustomerInfo/SendKFEmail";
        post(this.api.url,this.api.param).then(function (res) {
          if(res.IsOK){
            // that.$message.success('Your exclusive customer service has been informed');

             that.$confirm( 'Your exclusive customer service has been informed','',  {
                customClass:'custom-message-box', //自定义添加Class
                confirmButtonText: 'Confirm',
                cancelButtonText: 'Cancel',
                cancelButtonClass: 'btn-custom-cancel', //添加class,更换删除和取消按钮位置
                closeOnClickModal:false,//是否可通过点击遮罩关闭 MessageBox
                showCancelButton:false,//去掉取消按钮
                showClose:false,//去掉右上角的取消（X）
                // type: 'warning',
                center: true
              }).then(() => {
                that.emailBox=false        
                that.inpBorRed=false
                that.inpBorRed2=false
                that.Email=""
                that.Phone=""
                that.PlaPhone='Please enter your Phone'
                that.plaEmail='Please enter your Email'
              }).catch(() => {
      
              });

              setTimeout(() => {
                that.closeConfirm()
               },2000)

                that.emailBox=false        
                that.inpBorRed=false
                that.inpBorRed2=false
                that.Email=""
                that.Phone=""
                that.PlaPhone='Please enter your Phone'
                that.plaEmail='Please enter your Email'

               
          }else{
            that.$message.success('failed');
          }
            
        }) 
      }, 
    }
  }
</script>
<style scoped>
   @import "../../../assets/css/userCenterCss.css";
   
  .fyBorRed{border:1px solid red;border-radius:30px;}

  .pageBox{height:100%;width:100%;}
  .pageBanner{background:url('../../../../static/img/fyImg/fyBanner.jpg') no-repeat center;height:400px;width:100%}
  .pageContent{background:#116ef9;height:100%;padding-bottom:50px;}
  .pageContent .pageTop{width:1200px;margin:auto;overflow: hidden;background:#0b4cad;margin-bottom:30px}
  .pageContent .pageTop .leftTop{width:560px;height:100%;}
  .pageContent .pageTop .leftTop ul li{float:left;padding:20px 0px 20px 34px;}
  .pageContent .pageTop .rightTop{width:640px;height:360px;background:url('../../../../static/img/fyImg/fyVideoBg.jpg') no-repeat center;background-size:640px 360px;}
  .pageContent .pageTop .rightTop img{margin:auto;margin-top:130px;text-align: center;}

  .pageContent .pageMargin{background:#8fccff;width:1200px;margin:auto;height:100%;}
  .pageMargin .pageCountry{padding:20px}
  .pageMargin .pageCountry h2{text-align:center;padding-bottom:20px;color:black;font-size:24px;}
  .toTitle{font-size:16px;color:black;font-size:16px;line-height:30px;margin-right:5px;}
  .pageMargin .pageCountry .countryInput{width:425px;margin-left:400px;}
  .noteSet{text-align:center;font-size:13px;color:black;padding-top:15px;}

  .pageProduct{margin:0 20px;overflow: hidden;}
  .pageProduct ul li{float:left;background:#fff;width:270px;margin:10px 10px;height:457px;}
  .pageProduct ul li .buleBg{background:#1ac0ff;color:white;font-size:12px;line-height:30px;width:270px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    word-break: break-all;}
  .pageProduct ul li .proSet{padding:10px 10px 20px;}
  .pageProduct ul li .proSet h3{height:40px;text-overflow:-o-ellipsis-lastline;overflow:hidden;text-overflow:ellipsis;display:-webkit-box; -webkit-line-clamp:2;line-clamp:2;-webkit-box-orient:vertical;}
  .pageProduct ul li .labelBtn{margin:10px 0}
  .pageProduct ul li .labelBtn a{margin:4px 2px;position: relative;}
  .btn{width:74px;height:28px;line-height:28px; text-align:center;border:1px solid #666;display:inline-block;}
  .btnOn{background:#004fb1;color:white;border:1px solid #004fb1;}
  .iconYeSet{position:absolute;top:-6px;left:-6px;z-index:10;}
  .PriceBtn{background:#eb9200;color:#fff;width:130px;height:32px;line-height:32px;border-radius:30px;display:block;text-align:center;margin:auto;}

    
  .footerCentet{overflow: hidden;padding:30px 20px;}
  .footerLeft{float:left;width:200px;margin-top:10px;}
  .footerLeft img{margin:auto;}
  .footerRight{float:left;width:960px;color:black;}
  .footerRight p{line-height:24px;font-size:14px;}

  .emailSet{padding:10px 25px}
  .emailSet p{text-align:center;font-size:15px;}
  /*表格样式一*/
.detTable{width:100%;font-size:14px;}
.detTable tr th{font-size:14px;color:#000;padding:3px 0;}
.detTable tr td{font-size:13px;color:#666;padding:5px;line-height:26px;word-break:break-all;color:#000;}

  
  
</style>



// WEBPACK FOOTER //
// src/components/reception/otherPage/adepm.vue